<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jyMrBe/tc-custom/9781497685086.jpg?1702092114962" alt="This image is the cover for the book Across the Bridge"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Across the Bridge
      </h1>
      <p class="bookDescription body article font2">
        <b>A New York Times Best Book of the Year: Short stories centered around a French Canadian family that relocates to Paris in the years before WWII.</b><br/><br/> One of the greatest strengths of Mavis Gallant’s writing is her ability to distill a character’s emotions into a simple moment—a lingering glance or an unuttered word. Her flair for detail is everywhere in evidence in <i>Across the Bridge</i>, studies of Montreal and Paris over the last century.<br/><br/> The primary focus of this story collection is the Carettes, a family of French Canadians who relocate to Paris before World War II. The two daughters, Marie and Berthe, could not be more different: Marie is traditional and quiet while Berthe is strong willed and open minded. But as they grow together, the two learn how much they truly have in common.<br/><br/> Accompanying these stories of the Carettes are tales of growth and isolation at home and abroad, including one of a rebellious French-speaking Canadian girl growing up in the Anglophone area of the city. Another entry is focused on an anthropologist who, on a trip to a small country, finds a group of people who speak a language no one has ever heard before. Unfortunately, when he announces his discovery, no one believes him.<br/><br/> Gallant writes “elegant, witty tales of place and person” and cannily observes small domestic moments as her characters create and destroy the illusions in their lives (<i>Library Journal</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mavis Gallant
      </h2>
      
      <p class="authorDescription body article">In 1952 Mavis Gallant (1922&ndash;2014) left a successful career as a journalist in Montreal to live independently as a writer of fiction in Europe. She had gained international recognition in 1951 when she was published in the <I>New Yorker</I>, which in subsequent years released over one hundred of her short stories, most of which are set in European cities or Montreal. Random House published twelve volumes of her work. Gallant was awarded the 1981 Governor General&rsquo;s Award for&#160;<I>Home Truths</I>, the 2002 Rea Award for the Short Story, and the 2004 PEN/Nabokov Award for lifetime achievement.&#160;She was a companion of the Order of Canada, the country&rsquo;s highest honor. After traveling widely in Europe, in 1960 Gallant settled in Paris, where she died in 2014. <I>The Journals of Mavis Gallant: 1952&ndash;1969&#160;</I>is tentatively scheduled for publication by Alfred A. Knopf in 2015.&#160;<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2b7bdac4